import sofa from '@/public/images/for-business/furniture/1_sofa.webp';
import night from '@/public/images/for-business/furniture/2_night.webp';
import time from '@/public/images/for-business/furniture/3_time.webp';

export const forBusiness_furniture_elevate = [
	{
		image: sofa,
		columnTitle: 'elevateData_column1_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'elevateData_column1_title1',
				subtitle: 'elevateData_column1_subtitle1',
			},
			{
				icon: '🔹',
				title: 'elevateData_column1_title2',
				subtitle: 'elevateData_column1_subtitle2',
			},
			{
				icon: '🔹',
				title: 'elevateData_column1_title3',
				subtitle: 'elevateData_column1_subtitle3',
			},
		],
	},
	{
		image: night,
		columnTitle: 'elevateData_column2_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'elevateData_column2_title1',
				subtitle: 'elevateData_column2_subtitle1',
			},
			{
				icon: '🔹',
				title: 'elevateData_column2_title2',
				subtitle: 'elevateData_column2_subtitle2',
			},
			{
				icon: '🔹',
				title: 'elevateData_column2_title3',
				subtitle: 'elevateData_column2_subtitle3',
			},
		],
	},
	{
		image: time,
		columnTitle: 'elevateData_column3_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'elevateData_column3_title1',
				subtitle: 'elevateData_column3_subtitle1',
			},
			{
				icon: '🔹',
				title: 'elevateData_column3_title2',
				subtitle: 'elevateData_column3_subtitle2',
			},
			{
				icon: '🔹',
				title: 'elevateData_column3_title3',
				subtitle: 'elevateData_column3_subtitle3',
			},
		],
	},
];
